import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  Modal,
  ListItemIcon,
  Checkbox,
  ListItemText,
  IconButton,
  Button,
  Box,
  Stack,
  Typography,
  List,
  ListItem,
  ListItemButton,
  Card,
  Chip,
  TextField
} from "@mui/material";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CloseIcon from "@mui/icons-material/Close";
import {
  FETCH_EXTERNAL_JOB_TITLES,
  FETCH_JOB_POST_TYPES,
  FETCH_TRADES,
  FETCH_JOB_SEARCH_FILTERS,
  SAVE_JOB_SEARCH_FILTERS,
  DELETE_JOB_SEARCH_FILTERS
} from "../../constant/Apipath";
import { Postrequestcall } from "../../request/Postrequest";
import { useSelector } from "react-redux";
import { BIBlue, lightenHexColor } from "../../assets/helpers";
import Loader from "../../common/Loader";
import { English } from "../../constant/EnglishFallback";

const normalizeLabel = (value) =>
  String(value || "").toUpperCase().replace(/[^A-Z]/g, "");

const buildFilterSignature = (tradeIds = [], jobType, keyword, category) => {
  const trades = (tradeIds || [])
    .map((id) => String(id || "").trim())
    .filter(Boolean)
    .sort()
    .join(",");
  return `${normalizeLabel(jobType || "")}|${trades}|${String(keyword || "").trim().toLowerCase()}|${String(
    category || ""
  )
    .trim()
    .toLowerCase()}`;
};

const FilterListModal = (props) => {
  const {
    open,
    onClose,
    selectedTrades = [],
    selectedTypes = "",
    onApplyFilters,
    from = "",
    onSelectTrades,
    isExternal = false,
    searchTerm = "",
    categoryType = ""
  } = props;

  const { multiLanguageData, loginData } = useSelector((state) => state?.main);
  const LanguageData = multiLanguageData?.JobPostings || {};

  const {
    TEXT_FILTERS = English.JobPostings.TEXT_FILTERS,
    TEXT_TYPE = English.JobPostings.TEXT_TYPE,
    TEXT_SEARCH_BY_KEYWORD = English.JobPostings.TEXT_SEARCH_BY_KEYWORD,
    TEXT_SEARCH_PLACEHOLDER = English.JobPostings.TEXT_SEARCH_PLACEHOLDER,
    TEXT_CATEGORY_TITLE = English.JobPostings.TEXT_CATEGORY_TITLE,
    TEXT_CATEGORY_COMPANY = English.JobPostings.TEXT_CATEGORY_COMPANY,
    TEXT_CATEGORY_PUBLISHER = English.JobPostings.TEXT_CATEGORY_PUBLISHER,
    TEXT_CATEGORY_TRADE = English.JobPostings.TEXT_CATEGORY_TRADE,
    BUTTON_APPLY = English.JobPostings.BUTTON_APPLY || "APPLY",
    BUTTON_CLEARALL = English.JobPostings.BUTTON_CLEARALL || "CLEAR ALL",
    TEXT_DONE = English.JobPostings.TEXT_DONE || "Done",
    TEXT_SELECT_TRADES = English.JobPostings.TEXT_SELECT_TRADES || "Select Trade(s)",
    TEXT_SAVED_FILTERS = English.JobPostings.TEXT_SAVED_FILTERS || "Saved Filters",
    TEXT_NO_SAVED_FILTERS = English.JobPostings.TEXT_NO_SAVED_FILTERS || "No saved filters yet",
    TEXT_SAVE_FILTER_PROMPT =
      English.JobPostings.TEXT_SAVE_FILTER_PROMPT || "Save current filter to quick filters?",
    TEXT_FILTER_ALREADY_EXISTS =
      English.JobPostings.TEXT_FILTER_ALREADY_EXISTS || "This filter is already saved"
  } = LanguageData || {};

  const [tradeList, setTradeList] = useState([]);
  const [typeOptions, setTypeOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [keywordError, setKeywordError] = useState(false);
  const [selectedTypeValue, setSelectedTypeValue] = useState(
    selectedTypes || (isExternal ? "All" : "")
  );
  const [keywordSearch, setKeywordSearch] = useState(() => searchTerm);
  const [keywordFilterOpen, setKeywordFilterOpen] = useState(true);
  const [selectedKeywordChip, setSelectedKeywordChip] = useState(() => categoryType);
  const [activeTab, setActiveTab] = useState("filters");
  const [savedFilters, setSavedFilters] = useState([]);
  const [savedFiltersLoading, setSavedFiltersLoading] = useState(false);
  const [isSavingFilter, setIsSavingFilter] = useState(false);
  const [promptEnabled, setPromptEnabled] = useState(false);
  const [promptVisible, setPromptVisible] = useState(false);
  const [pendingSave, setPendingSave] = useState(null);
  const promptTimerRef = useRef(null);

  const isFromPostAJob = from === "postAJob";
  const filterTabs = isFromPostAJob
    ? [{ key: "filters", label: TEXT_SELECT_TRADES }]
    : [
        { key: "filters", label: TEXT_FILTERS },
        { key: "saved", label: TEXT_SAVED_FILTERS }
      ];

  const fetchJobPostTypes = useCallback(async () => {
    try {
      const obj = {
        PageNr: 1,
        NrOfRecPerPage: 20,
        FullSearch: "",
        UserId: loginData?.userInformation?.UserId || 1,
        IncludeRecordNr: "true",
        TypeOfObjectReturned: "",
        FetchAllowedRecordsOnly: true,
        SearchList: [],
        SortList: [{}]
      };
      const res = await Postrequestcall(FETCH_JOB_POST_TYPES, obj, loginData?.accessToken);
      const resData = res?.data?.data || [];
      const updatedData = resData?.map((value) => ({ value: value.id, label: value.typeName }));
      setTypeOptions(updatedData);
    } catch (error) {
      console.error("fetchJobPostTypes ->", error);
    }
  }, [loginData]);

  const fetchTradesList = useCallback(async () => {
    try {
      let obj;
      let apiPath;
      if (isExternal) {
        apiPath = FETCH_EXTERNAL_JOB_TITLES;
        obj = {
          PageNr: 1,
          NrOfRecPerPage: 20,
          FullSearch: "",
          UserId: loginData?.userInformation?.UserId || "1",
          IncludeRecordNr: "true",
          TypeOfObjectReturned: "",
          FetchAllowedRecordsOnly: false,
          SearchList: [{}],
          SortList: [{}]
        };
      } else {
        apiPath = FETCH_TRADES;
        obj = {
          PageNr: 1,
          FullSearch: "",
          SearchList: [{}],
          IncludeRecordNr: false,
          TypeOfObjectReturned: "NameOnly",
          FetchAllowedRecordsOnly: true
        };
      }
      const res = await Postrequestcall(apiPath, obj, loginData?.accessToken);
      const resData = res?.data?.data || [];
      const tradesData = resData.map((value) => ({
        value: value.id,
        label: value.typeName || value.name || value.jobTitle || "",
        isChecked: isFromPostAJob
          ? selectedTrades.some((t) => t.value === value.id)
          : selectedTrades.includes(value.id)
      }));
      setTradeList(tradesData);
    } catch (error) {
      console.error("fetchTradesList ->", error);
    }
  }, [isExternal, loginData, selectedTrades, isFromPostAJob]);

  const fetchOptions = useCallback(async () => {
    try {
      setIsLoading(true);
      await Promise.all([fetchJobPostTypes(), fetchTradesList()]);
    } finally {
      setIsLoading(false);
    }
  }, [fetchJobPostTypes, fetchTradesList]);

  const loadSavedFilters = useCallback(async () => {
    const userId = loginData?.userInformation?.UserId;
    if (!userId) return;
    setSavedFiltersLoading(true);
    try {
      const payload = {
        PageNr: 1,
        NrOfRecPerPage: 20,
        FullSearch: "",
        UserId: userId,
        IncludeRecordNr: true,
        TypeOfObjectReturned: "",
        FetchAllowedRecordsOnly: false,
        SearchList: [{}],
        SortList: [{}]
      };
      const res = await Postrequestcall(FETCH_JOB_SEARCH_FILTERS, payload, loginData?.accessToken);
      const filters = (res?.data?.data || []).map((filter) => {
        const tradeIdsRaw = (filter?.tradeIds ?? filter?.TradeIds ?? "").toString();
        const tradeIds = tradeIdsRaw
          .split(",")
          .map((value) => value?.trim())
          .filter(Boolean);
        const jobType = filter?.jobType ?? filter?.JobType;
        const searchString = filter?.searchString ?? filter?.SearchString;
        const categoryLabel = filter?.category ?? filter?.Category;
        return {
          ...filter,
          signature: buildFilterSignature(tradeIds, jobType, searchString, categoryLabel)
        };
      });
      setSavedFilters(filters);
    } catch (error) {
      console.error("loadSavedFilters ->", error);
    } finally {
      setSavedFiltersLoading(false);
    }
  }, [loginData]);

  useEffect(() => {
    if (open) {
      fetchOptions();
      loadSavedFilters();
    }
  }, [open, fetchOptions, loadSavedFilters]);

  useEffect(() => {
    setKeywordSearch(searchTerm);
    setSelectedKeywordChip(categoryType);
  }, [searchTerm, categoryType]);

  useEffect(() => {
    if (!promptEnabled || activeTab !== "filters") {
      setPromptVisible(false);
      setPendingSave(null);
      return;
    }
    const selectedIds = tradeList.filter((item) => item.isChecked).map((item) => item.value);
    const hasActiveFilter =
      selectedIds.length > 0 ||
      (selectedTypeValue && selectedTypeValue !== "" && selectedTypeValue !== "All") ||
      (keywordSearch && keywordSearch.trim() !== "") ||
      (selectedKeywordChip && selectedKeywordChip !== "");
    if (!hasActiveFilter) {
      setPromptVisible(false);
      setPendingSave(null);
      return;
    }
    const signature = buildFilterSignature(
      selectedIds,
      selectedTypeValue,
      keywordSearch,
      selectedKeywordChip
    );
    if (savedFilters.some((filter) => filter.signature === signature)) {
      setPromptVisible(false);
      setPendingSave(null);
      return;
    }
    setPendingSave({
      trades: selectedIds,
      types: selectedTypeValue,
      keyword: keywordSearch,
      category: selectedKeywordChip,
      signature
    });
    setPromptVisible(true);
  }, [
    promptEnabled,
    activeTab,
    selectedTypeValue,
    keywordSearch,
    selectedKeywordChip,
    tradeList,
    savedFilters
  ]);

  useEffect(() => {
    if (!open) {
      setPromptEnabled(false);
      setPromptVisible(false);
      setPendingSave(null);
    }
  }, [open]);

  useEffect(() => {
    if (!promptVisible) {
      clearTimeout(promptTimerRef.current);
      promptTimerRef.current = null;
      return;
    }
    clearTimeout(promptTimerRef.current);
    promptTimerRef.current = setTimeout(() => {
      setPromptVisible(false);
      setPromptEnabled(false);
      setPendingSave(null);
    }, 8000);
    return () => {
      clearTimeout(promptTimerRef.current);
    };
  }, [promptVisible]);

  const triggerPrompt = () => setPromptEnabled(true);

  const onTypeClick = (type) => {
    setSelectedTypeValue((prev) => (prev === type.value ? "" : type.value));
    triggerPrompt();
  };

  const onTradeClick = (trade) => {
    const updated = tradeList.map((item) =>
      item.value === trade.value ? { ...item, isChecked: !item.isChecked } : item
    );
    setTradeList(updated);
    triggerPrompt();
  };

  const onKeywordChange = (value) => {
    setKeywordSearch(value);
    triggerPrompt();
  };

  const onKeywordChipClick = (label) => {
    if (!keywordSearch.trim()) {
      setKeywordError(true);
      return;
    }
    setKeywordError(false);
    setSelectedKeywordChip(label);
    triggerPrompt();
  };

  const saveCurrentFilter = async (payloadData) => {
    if (!payloadData) return;
    const { trades, types, keyword, category } = payloadData;
    const userId = loginData?.userInformation?.UserId;
    if (!userId) return;
    const selectedType = typeOptions.find((type) => type.value == types);
    const jobType = normalizeLabel(selectedType?.label);
    const payload = {
      UserId: userId,
      ReturnRecordId: true,
      ReturnRecordError: true,
      SaveList: [
        {
          Id: 0,
          UserId: userId,
          TradeIds: (trades || []).join(","),
          JobType: jobType,
          Category: category || "",
          SearchString: keyword || "",
          ModifiedBy: userId
        }
      ]
    };
    setIsSavingFilter(true);
    try {
      await Postrequestcall(SAVE_JOB_SEARCH_FILTERS, payload, loginData?.accessToken);
      await loadSavedFilters();
    } catch (error) {
      console.error("saveCurrentFilter ->", error);
    } finally {
      setIsSavingFilter(false);
    }
  };

  const handleSavePrompt = async () => {
    if (!pendingSave) return;
    if (savedFilters.some((filter) => filter.signature === pendingSave.signature)) {
      window.alert(TEXT_FILTER_ALREADY_EXISTS);
      setPromptVisible(false);
      setPromptEnabled(false);
      return;
    }
    await saveCurrentFilter(pendingSave);
    setPendingSave(null);
    setPromptVisible(false);
    setPromptEnabled(false);
    onClose();
  };

  const handleSkipPrompt = () => {
    setPromptVisible(false);
    setPromptEnabled(false);
    setPendingSave(null);
  };

  const handleApplySavedFilter = (filter) => {
    const tradeIds = (filter?.tradeIds ?? filter?.TradeIds ?? "")
      .toString()
      .split(",")
      .map((value) => Number(value))
      .filter(Boolean);
    const normalizedFilterType = normalizeLabel(filter?.jobType ?? filter?.JobType);
    const matchedType = typeOptions.find((type) => normalizeLabel(type.label) === normalizedFilterType);
    setTradeList((prev) =>
      prev.map((trade) => ({
        ...trade,
        isChecked: tradeIds.includes(Number(trade.value))
      }))
    );
    setSelectedTypeValue(matchedType ? matchedType.value : "");
    setKeywordSearch(filter?.searchString ?? (filter?.SearchString || ""));
    setSelectedKeywordChip(filter?.category ?? (filter?.Category || ""));
    onApplyFilters({
      trades: tradeIds,
      types: matchedType ? matchedType.value : "",
      keyword: filter?.searchString ?? filter?.SearchString ?? "",
      categoryType: filter?.category ?? filter?.Category ?? ""
    });
    setPromptEnabled(false);
    setPromptVisible(false);
    setPendingSave(null);
    onClose();
  };

  const handleDeleteSavedFilter = async (filterId) => {
    const userId = loginData?.userInformation?.UserId;
    if (!filterId || !userId) return;
    setSavedFiltersLoading(true);
    try {
      const payload = {
        UserId: userId,
        ReturnRecordId: false,
        ReturnRecordError: true,
        SoftDelete: true,
        DeleteList: [{ Id: filterId }]
      };
      await Postrequestcall(DELETE_JOB_SEARCH_FILTERS, payload, loginData?.accessToken);
      await loadSavedFilters();
    } catch (error) {
      console.error("handleDeleteSavedFilter ->", error);
    } finally {
      setSavedFiltersLoading(false);
    }
  };

  const renderSavedFilters = () => {
    if (savedFiltersLoading) {
      return (
        <Stack sx={{ height: "220px" }} alignItems="center" justifyContent="center">
          <Loader />
        </Stack>
      );
    }
    if (!savedFilters.length) {
      return (
        <Box sx={{ py: 4, textAlign: "center" }}>
          <Typography variant="body2" color="textSecondary">
            {TEXT_NO_SAVED_FILTERS}
          </Typography>
        </Box>
      );
    }
    return (
      <Stack spacing={2}>
          {savedFilters.map((filter) => {
            const fallbackTradeIds = (filter?.tradeIds ?? filter?.TradeIds ?? "")
              .toString()
              .split(",")
              .map((value) => value?.trim())
              .filter(Boolean);
            const tradeLabels = (filter?.trades || [])
              .map((trade) => trade?.tradeName || trade?.name || trade?.jobTitle)
              .filter(Boolean);
            if (!tradeLabels.length && fallbackTradeIds.length) {
              tradeLabels.push(...fallbackTradeIds);
            }
            return (
            <Card
              key={filter?.Id || filter?.id}
              sx={{ p: 2, borderRadius: "14px", boxShadow: "0px 8px 20px rgba(0,0,0,0.08)" }}>
              <Stack spacing={1}>
                <Stack direction="row" justifyContent="space-between" alignItems="center">
                  <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                    {filter?.SearchString || filter?.searchString || "Quick Filter"}
                  </Typography>
                  <Stack direction="row" spacing={0.5}>
                    <Button size="small" variant="text" onClick={() => handleApplySavedFilter(filter)}>
                      APPLY
                    </Button>
                    <IconButton size="small" onClick={() => handleDeleteSavedFilter(filter?.Id || filter?.id)}>
                      <CloseIcon />
                    </IconButton>
                  </Stack>
                </Stack>
                <Stack direction="row" spacing={1} alignItems="center">
                  <Typography variant="body2" color="textSecondary">
                    Category: {filter?.category || filter?.Category || "All"}
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    Job type: {filter?.jobType || filter?.JobType || "All"}
                  </Typography>
                </Stack>
                <Typography variant="body2" color="textSecondary">
                  Search: {filter?.searchString || filter?.SearchString || "All"}
                </Typography>
                {tradeLabels.length > 0 ? (
                  <Stack direction="row" flexWrap="wrap" spacing={0.5}>
                    {tradeLabels.slice(0, 3).map((label, index) => (
                      <Chip key={`${label}-${index}`} label={label} size="small" />
                    ))}
                    {tradeLabels.length > 3 && <Chip label={`+${tradeLabels.length - 3} more`} size="small" />}
                  </Stack>
                ) : (
                  <Typography variant="body2" color="textSecondary">
                    Trades: All
                  </Typography>
                )}
              </Stack>
            </Card>
          );
        })}
      </Stack>
    );
  };

  const onApplyClick = () => {
    const selectedIds = tradeList.filter((item) => item.isChecked).map((item) => item.value);
    onApplyFilters({
      trades: selectedIds,
      types: selectedTypeValue || "",
      keyword: keywordSearch,
      categoryType: selectedKeywordChip
    });
    onClose();
  };

  const onDoneClick = () => {
    const trades = tradeList.filter((item) => item.isChecked);
    onSelectTrades(trades);
    onClose();
  };

  const onClearAllClick = () => {
    setTradeList((prev) => prev.map((item) => ({ ...item, isChecked: false })));
    setSelectedTypeValue("");
    setKeywordSearch("");
    setSelectedKeywordChip("");
    setPromptEnabled(false);
    setPromptVisible(false);
    setPendingSave(null);
  };

  const renderSavePrompt = () => {
    if (!promptVisible || !pendingSave) return null;
    return (
      <Box
        sx={{
          mt: 1,
          px: 1.25,
          py: 0.75,
          borderRadius: 1.5,
          border: "1px solid #dfe4ea",
          backgroundColor: "#f8f9ff",
          boxShadow: "0 2px 8px rgba(0,0,0,0.06)"
        }}>
        <Stack direction="row" alignItems="center" spacing={1} justifyContent="space-between">
          <Stack direction="row" alignItems="center" spacing={0.75} sx={{ flex: 1, minWidth: 0 }}>
            <NotificationsActiveIcon sx={{ color: "#2c74ff", fontSize: 20 }} />
            <Typography
              variant="body2"
              sx={{ fontSize: "0.85rem", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
              {TEXT_SAVE_FILTER_PROMPT}
            </Typography>
          </Stack>
          <Stack direction="row" spacing={0.5} sx={{ pl: 1 }}>
            <Button
              size="small"
              variant="text"
              onClick={handleSkipPrompt}
              sx={{ textTransform: "none", fontWeight: 600, fontSize: "0.75rem" }}>
              Not now
            </Button>
            <Button
              size="small"
              variant="contained"
              onClick={handleSavePrompt}
              disabled={isSavingFilter}
              sx={{ textTransform: "none", fontWeight: 600, fontSize: "0.75rem" }}>
              {isSavingFilter ? "Saving..." : "Save to quick filters"}
            </Button>
          </Stack>
        </Stack>
      </Box>
    );
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box className="user-modal-responsive" sx={{ display: "flex", flexDirection: "column", maxHeight: "90vh" }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
            pb: 1,
            borderBottom: "1px solid #eee"
          }}>
          <Typography variant="h6" sx={{ fontSize: 18 }}>
            {activeTab === "saved" ? TEXT_SAVED_FILTERS : isFromPostAJob ? TEXT_SELECT_TRADES : TEXT_FILTERS}
          </Typography>
          <Stack flexDirection="row">
            <IconButton onClick={onClose}>
              <CloseIcon />
            </IconButton>
          </Stack>
        </Box>
        <Stack direction="row" spacing={1} sx={{ mt: 1, px: 1 }}>
          {filterTabs.map((tab) => (
            <Button
              key={tab.key}
              variant={activeTab === tab.key ? "contained" : "text"}
              size="small"
              onClick={() => setActiveTab(tab.key)}
              sx={{
                textTransform: "none",
                borderRadius: 2,
                px: 2,
                py: 0.75,
                fontWeight: 600,
                border: activeTab === tab.key ? "none" : "1px solid #d0d0d0"
              }}>
              {tab.label}
            </Button>
          ))}
        </Stack>
        <Box sx={{ flex: 1, overflowY: "auto", mt: 1, pr: 0.5, px: 1 }}>
          {activeTab === "filters" ? (
            !isLoading ? (
              <>
                {!isFromPostAJob && (
                  <Box sx={{ mb: 3 }}>
                    <Stack
                      direction="row"
                      alignItems="center"
                      justifyContent="space-between"
                      onClick={() => setKeywordFilterOpen((prev) => !prev)}
                      sx={{ cursor: "pointer", mb: 1 }}>
                      <Typography variant="h6">{TEXT_SEARCH_BY_KEYWORD}</Typography>
                      <IconButton size="small">
                        {keywordFilterOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                      </IconButton>
                    </Stack>
                    {keywordFilterOpen && (
                      <Box sx={{ mt: 1 }}>
                        <TextField
                          error={keywordError}
                          fullWidth
                          placeholder={
                            selectedKeywordChip ? `Search by ${selectedKeywordChip}` : TEXT_SEARCH_PLACEHOLDER
                          }
                          value={keywordSearch}
                          onChange={(e) => onKeywordChange(e.target.value)}
                          size="small"
                          sx={{ mb: 1.5 }}
                        />
                        <Stack direction="row" gap={1} flexWrap="wrap">
                          {[TEXT_CATEGORY_TITLE, TEXT_CATEGORY_COMPANY, TEXT_CATEGORY_PUBLISHER, TEXT_CATEGORY_TRADE].map(
                            (label) => (
                              <Chip
                                key={label}
                                label={label}
                                onClick={() => onKeywordChipClick(label)}
                                variant={selectedKeywordChip === label ? "filled" : "outlined"}
                                sx={{
                                  backgroundColor: selectedKeywordChip === label ? BIBlue : "transparent",
                                  color: selectedKeywordChip === label ? "white" : "black",
                                  borderColor:
                                    selectedKeywordChip === label ? BIBlue : "rgba(0, 0, 0, 0.23)",
                                  cursor: "pointer"
                                }}
                              />
                            )
                          )}
                        </Stack>
                      </Box>
                    )}
                  </Box>
                )}
                {renderSavePrompt()}
                {!isFromPostAJob && (
                  <Stack sx={{ mb: 2 }}>
                    <Typography variant="h6">{TEXT_TYPE}</Typography>
                    <Stack direction="row" alignItems="center" flexWrap="wrap" gap={1} sx={{ mt: 0.5 }}>
                      {typeOptions?.map((type) => (
                        <Chip
                          key={type.value}
                          label={type.label}
                          onClick={() => onTypeClick(type)}
                          variant={type.value == selectedTypeValue ? "filled" : "outlined"}
                          sx={{
                            backgroundColor:
                              type.value == selectedTypeValue ? lightenHexColor(BIBlue, 80) : "",
                            color: type.value == selectedTypeValue ? BIBlue : "",
                            cursor: "pointer"
                          }}
                        />
                      ))}
                    </Stack>
                  </Stack>
                )}
                <>
                  {!isFromPostAJob && (
                    <Typography variant="h6" sx={{ mt: 2, mb: 1 }}>
                      {TEXT_CATEGORY_TRADE}
                    </Typography>
                  )}
                  <Box>
                    <List disablePadding>
                      <Stack gap={1}>
                        {tradeList?.map((trade, index) => (
                          <Card key={index} className="pagelist-content" sx={{ marginTop: "0px" }}>
                            <ListItem disablePadding>
                              <ListItemButton onClick={() => onTradeClick(trade)} dense>
                                <ListItemIcon sx={{ minWidth: "10px" }}>
                                  <Checkbox edge="start" checked={trade.isChecked} disableRipple />
                                </ListItemIcon>
                                <ListItemText primary={trade.label} />
                              </ListItemButton>
                            </ListItem>
                          </Card>
                        ))}
                      </Stack>
                    </List>
                  </Box>
                </>
              </>
            ) : (
              <Stack sx={{ height: "400px" }} alignItems="center" justifyContent="center">
                <Loader />
              </Stack>
            )
          ) : (
            <Box sx={{ mt: 1, mb: 2 }}>{renderSavedFilters()}</Box>
          )}
        </Box>
        <Box sx={{ pt: 2, borderTop: "1px solid #eee" }}>
          <Stack direction="row" alignItems="center" justifyContent="space-between">
            {isFromPostAJob ? (
              <>
                <Typography></Typography>
                <Button variant="contained" onClick={onDoneClick}>
                  {TEXT_DONE}
                </Button>
              </>
            ) : (
              <>
                <Button variant="text" onClick={onClearAllClick}>
                  {BUTTON_CLEARALL}
                </Button>
                <Button variant="contained" onClick={onApplyClick}>
                  {BUTTON_APPLY}
                </Button>
              </>
            )}
          </Stack>
        </Box>
      </Box>
    </Modal>
  );
};

export default FilterListModal;
